export const copyPlainText = async (text) => {
  try {
    if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(text); return; }
  } catch { /* Embedded previews may deny async clipboard permission. */ }
  const input = document.createElement('textarea');
  input.value = text;
  input.setAttribute('readonly', '');
  input.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:1px;opacity:0;pointer-events:none;';
  const focused = document.activeElement;
  document.body.appendChild(input);
  try {
    input.focus({ preventScroll: true }); input.select();
    if (!document.execCommand('copy')) throw new Error('Clipboard unavailable');
  } finally {
    input.remove(); focused?.focus?.({ preventScroll: true });
  }
};